import { render } from "./AccountSettingsPage.vue?vue&type=template&id=3a530122&ts=true"
import script from "./AccountSettingsPage.vue?vue&type=script&lang=ts"
export * from "./AccountSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__